
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.667.811v2.635c0 .59 0 1.389.416 1.805.417.417 1.216.417 1.806.417h2.688c.06.177.09.362.09.55v10.2c0 .464-.187.91-.519 1.237a1.782 1.782 0 01-1.252.513H2.27c-.47 0-.92-.184-1.252-.513A1.74 1.74 0 01.5 16.418v-14c0-.464.187-.91.519-1.237A1.782 1.782 0 012.27.668h6.694c.243 0 .482.05.702.143zm-6 8.19a1 1 0 011-1H10.5a1 1 0 110 2H4.667a1 1 0 01-1-1zm1 3.167a1 1 0 100 2h5a1 1 0 100-2h-5z","fill":"#757575"}})])
          )
        }
      }
    